import React, { useContext } from 'react';

import type { UserLabelFragment } from '../../graphql/hasura/generated';
import { ModelsContext } from '../../hooks/providers';
import { formatTimestamp } from '../../utils';

interface IChangedAtTimeByUserProps {
  changedAt: string;
  changedByUser?: UserLabelFragment | null;
}

export const ChangedAtTimeByUser: React.FC<IChangedAtTimeByUserProps> = (props) => {
  const { changedAt, changedByUser } = props;
  const { getModel } = useContext(ModelsContext);
  const UserModel = getModel('User');

  return (
    <>
      {formatTimestamp(changedAt)}
      {changedByUser && (
        <> by {UserModel.routes.renderRowLink(changedByUser)}</>
      )}
    </>
  );
};
